export const AUTOPLAY_GUIDE_ID = 'autoplay';
export const PAYMENT_COMPLETE_GUIDE_ID = 'paymentcomplete';
export const BROWSIES_GUIDE_ID = 'browsies';
export const RECENTS_GUIDE_ID = 'recents';
